<template>
  <IQOS :title="$t('online_payment.company_details.title')" required>
    <BaseSelect
      class="w-100 mt-16"
      fullWidth
      v-model="edit_fields.company_type"
      :placeholder="$t('online_payment.company_details.type_ph')"
      :disabled="!editing"
    >
      <option
        v-for="company_type in regionalCompanyTypes"
        :key="company_type"
        :value="company_type"
      >
        {{ company_type }}
      </option>
    </BaseSelect>
    <BaseInput
      class="w-100 mt-16"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.company_name"
      :placeholder="$t('online_payment.company_details.name_ph')"
    />
    <BaseInput
      class="w-100 mt-16"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.company_account"
      :placeholder="$t('online_payment.company_details.account_ph')"
    />
    <BaseInput
      class="w-100 mt-16"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.company_code"
      :placeholder="$t('online_payment.company_details.code_ph')"
    />
    <BaseInput
      class="w-100 mt-16"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.company_tax_id"
      :placeholder="$t('online_payment.company_details.tax_ph')"
    />
    <BaseInput
      class="w-100 mt-16"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.company_address"
      :placeholder="$t('online_payment.company_details.address_ph')"
    />

    <BaseInput
      class="w-100 mt-16"
      fullWidth
      :disabled="!editing"
      v-model="edit_fields.company_email"
      :placeholder="$t('online_payment.company_details.email_ph')"
    />
    <BaseInput
      class="w-100 mt-16"
      fullWidth
      v-model="edit_fields.company_phone"
      :readonly="!editing"
      :dark="!editing"
      :disabled="!editing"
      :placeholder="$t('online_payment.company_details.phone_ph')"
    />

    <template #actions>
      <IQOSActions
        :editing="editing"
        @edit="showEditUI"
        @cancel="hideEditUI"
        @accept="onEditFinish"
      />
    </template>
  </IQOS>
</template>

<script>
export default {
  props: {
    merchant: Object,
  },
  data() {
    return {
      editing: false,
      edit_fields: {
        company_type: null,
        company_name: null,
        company_address: null,
        company_account: null,
        company_phone: null,
        company_code: null,
        company_email: null,
        company_tax_id: null,
      },
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.editing = false;

      this.$emit("update", this.merchant._id, this.edit_fields);
    },
    reset() {
      Object.keys(this.edit_fields).forEach(
        (k) => (this.edit_fields[k] = this.merchant[k])
      );
    },
  },
  mounted() {
    this.reset();
  },
  computed: {
    regionalCompanyTypes() {
      const value = this.$store.state.worldwide.region.company_types || "";

      return value.split(",");
    },
  },
};
</script>

<style scoped>
</style>
